import React from 'react'

import { AdvancedFilters } from 'features/views/ListView/ListHeader/Filters/Advanced/AdvancedFilters'

import { Box } from 'ui/components/Box'

import { useToolbarState } from './hooks/useToolbarState'
import { SelectedRecordsActions } from './SelectedRecordsActions'
import { ToolbarActions } from './ToolbarActions'
import { ToolbarSearchBar } from './ToolbarSearchBar'
import { TrashModeToolbar } from './TrashModeToolbar'

import { ToolbarFiltersBottomBarStyle, ToolbarStyle, ToolbarTopBarStyle } from './Toolbar.css'

type ToolbarProps = {}

export const Toolbar: React.FC<ToolbarProps> = () => {
    const { hasRecordsSelected, isTrashMode, isFiltersPaneOpen } = useToolbarState()

    return (
        <Box className={ToolbarStyle}>
            {hasRecordsSelected && !isTrashMode && <SelectedRecordsActions />}
            {!hasRecordsSelected && !isTrashMode && (
                <>
                    <Box className={ToolbarTopBarStyle}>
                        <ToolbarSearchBar />
                        <ToolbarActions />
                    </Box>
                    {isFiltersPaneOpen && (
                        <Box className={ToolbarFiltersBottomBarStyle}>
                            <AdvancedFilters width="full" />
                        </Box>
                    )}
                </>
            )}
            {isTrashMode && <TrashModeToolbar />}
        </Box>
    )
}
